<template>
  <v-container fluid>
    <DataTable
      :items.sync="ticketDetails"
      :headers="headers"
      :customCells="customTicketSummaryCells"
      :hideHeader="true"
      >
        <template #ticket-number="{item}">
          {{getTicketNumber(item)}}
        </template>
        <template #product="{item}">
          {{item.productName}}
        </template>
        <template #net-weight-tons="{item}">
          {{tonStringFromPounds(item.netWeight)}}
          <Icon
            v-if="item.loadDefects.length > 0"
            iconColor="black"
            dataTestId="ticket-sum-view-defect"
            @icon-clicked="viewTicketDefects(item)"
            icon="mdi-dots-horizontal-circle-outline"
            tooltipText="View Defects"/>
        </template>
        <template #net-volume="{item}">
          {{mbfStringFromBf(item.netVolume)}}
        </template>
        <template #body.append>
          <tr class="font-weight-bold">
            <td v-for="header in headers" :key="header.value" :class="`text-${header.align}`">{{totalsByColumn[header.value]}}</td>
          </tr>
      </template>
    </DataTable>
    <Dialog :stateId="dialogId" @close="close">
      <TicketDefectCard
        v-if="ticketDefectsDialog"
        :ticketDefects="focusedDefects"
        @close="close"
      />
    </Dialog>
  </v-container>
</template>

<script>
import { ticketRegisterContractSummaryHeaders } from '@/headers/Cycles.js'
import { customTicketSummaryCells } from '@/components/settlements/accounts-payable-module/ticket-register/CustomTicketSummaryCells.js'
import { tonStringFromPounds, mbfStringFromBf } from '@/utils/NumericMutations.js'
import { mapActions } from 'vuex'
export default {
  name: 'TicketSummaryCard',

  props: {
    ticketDetails: {
      type: Array,
      required: true
    }
  },

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    TicketDefectCard: () => import('@/components/defects/TicketDefectCard.vue'),
    Dialog: () => import('@/components/Dialog.vue'),
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    contractDialog: false,
    ticketDefectsDialog: false,
    focusedDefects: undefined,
    dialogId: 'ticket-summary-defect',
    customTicketSummaryCells
  }),

  computed: {
    sums () {
      return this.ticketDetails.reduce((acc, t) => {
        acc.totalNetWeight += t.inWeight - t.outWeight - t.defectWeight
        acc.totalNetVolume += t.netVolume
        return acc
      }, {
        totalNetWeight: 0,
        totalNetVolume: 0
      })
    },

    totalsByColumn () {
      return {
        ticketNumber: this.$t('totals'),
        netWeight: tonStringFromPounds(this.sums.totalNetWeight),
        netVolume: mbfStringFromBf(this.sums.totalNetVolume)
      }
    },

    hasVolumeData () {
      return this.ticketDetails.some(t => t.netVolume > 0 || t.grossVolume > 0)
    },

    headers () {
      return ticketRegisterContractSummaryHeaders().getColumns()
        .filter(h => this.hasVolumeData || h.value !== 'netVolume')
    }
  },

  methods: {
    ...mapActions('dialog', ['openOrUpdateDialog', 'closeDialogsAtOrAbove']),
    tonStringFromPounds,
    mbfStringFromBf,

    viewTicketDefects (ticket) {
      this.dialogId = `ticket-summary-defect-${ticket.ticketId}`
      this.focusedDefects = ticket.loadDefects
      this.ticketDefectsDialog = true
      this.$nextTick(() => {
        this.openOrUpdateDialog({ id: this.dialogId, width: '50vw' })
      })
    },

    getTicketNumber ({ ticketNumber, extTicketNumber1 }) {
      var str = `${ticketNumber}`

      if (extTicketNumber1 !== '' && extTicketNumber1 !== null && extTicketNumber1 !== undefined) {
        str += ` (${extTicketNumber1})`
      }

      return str
    },

    close () {
      this.focusedDefects = undefined
      this.ticketDefectsDialog = false
      this.closeDialogsAtOrAbove(this.dialogId)
    }
  }
}
</script>
